import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card, Tab, Tabs } from "react-bootstrap";
import Spinner from "views/lib/components/Spinner";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { getItem } from "actions/scooter/scooter/actions";

import Info from "./info";
import ScooterSingleHistory from "./scooter-single-history";

class ScooterSingle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      item: {}
    };

    this.fetchItem = this.fetchItem.bind(this);
  }

  componentDidMount() {
    this.fetchItem();
  }

  fetchItem(timeOut = 0) {
    setTimeout(() => {
      this.props.getItem(this.props.match.params.id, item => {
        this.setState({ item });
      });
    }, timeOut);
  }

  render() {
    // const { id } = this.props.match.params;
    const { item } = this.state;
    const { loading } = this.props;

    return (
      <div className="m-2 position-relative">
        {!loading || <Spinner/>}

        {Object.keys(item).length ? (
          <React.Fragment>
            <Card className="rounded-0">
              <Card.Header>
                <div className="d-flex justify-content-between">
                  <div className="d-inline-flex align-items-center">
                    Scooter
                  </div>
                </div>
              </Card.Header>
              <Card.Body>
                <Info
                  item={item}
                  onAction={(t = 3000) => this.fetchItem(t)}
                />
              </Card.Body>
            </Card>

            <Tabs defaultActiveKey="history" id="scooter-history-tabs">
              <Tab eventKey="history" title="History (last 10)">
                <ScooterSingleHistory scooterId={this.props.match.params.id} />
              </Tab>
              {/* <Tab eventKey="path" title="Trip last">
                <BikePath bikeId={bikeId} />
              </Tab> */}
            </Tabs>
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.scooter.loading,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getItem: bindActionCreators(getItem, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ScooterSingle);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/scooter/single/index.js